import ProductPriceProvider from './hooks/useProductPrice';

import { ProductPriceProps } from './@types/ProductPriceProps';

import './ProductPrice.scss';
import { FlexLayout } from '../../flex-layout/FlexLayout/FlexLayout';
import ProductListPrice from '../ProductListPrice/ProductListPrice';
import ProductSellingPrice from '../ProductSellingPrice/ProductSellingPrice';
import ProductInstallments from '../ProductInstallments/ProductInstallments';

const ProductPrice = (props: ProductPriceProps) => (
	<ProductPriceProvider {...props}>
		<FlexLayout.Row blockClass="list-price">
			<ProductListPrice componentId={props.componentId} />
		</FlexLayout.Row>
		<FlexLayout.Row blockClass="selling-price">
			<ProductSellingPrice componentId={props.componentId} />
		</FlexLayout.Row>
		<FlexLayout.Row blockClass="installments-price">
			<ProductInstallments componentId={props.componentId} />
		</FlexLayout.Row>
	</ProductPriceProvider>
);

export default ProductPrice;
